<template>
  <div class="container">
    <div class="mwow-detail-header">
      <div class="left">
        <div class="back-btn" @click="$router.go(-1)">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
      </div>
      <div class="mid">
        <p>课包详情</p>
      </div>
      <div class="right"></div>
    </div>
    <el-form
      size="mini"
      :model="packageForm"
      label-width="88px"
      ref="mainForm"
      :rules="rules"
      class="mwow-form"
    >
      <el-form-item label="课包名称:" prop="name">
        <el-input
          v-model="packageForm.name"
          placeholder="请输入课包名称"
          maxlength="20"
          style="width: 500px"
        ></el-input>
      </el-form-item>
      <el-form-item label="课时数:" prop="quantity">
        <el-input
          v-model="packageForm.quantity"
          placeholder="请输入课时数"
          type="number"
          style="width: 500px"
          :disabled="$route.query.id !== '0'"
        ></el-input>
      </el-form-item>
      <el-form-item label="状态: " prop="status">
        <el-radio-group
          v-model="packageForm.status"
          size="mini"
          :disabled="isBasePackage"
        >
          <el-radio-button :label="1">上架</el-radio-button>
          <el-radio-button :label="2">下架</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="价格: ">
        <!-- <p class="price-title">（至少填写一个）</p> -->
      </el-form-item>
      <el-form-item label="1v1:" prop="price_1v1">
        <el-input
          v-model="packageForm.price_1v1"
          placeholder="请输入价格"
          type="number"
          style="width: 500px"
        ></el-input>
      </el-form-item>
      <el-form-item label="1vN:" prop="price_1vn">
        <el-input
          v-model="packageForm.price_1vn"
          placeholder="请输入价格"
          type="number"
          style="width: 500px"
        ></el-input>
      </el-form-item>
      <el-form-item label="关联课程: " prop="relation_type">
        <div class="relate-wrap">
          <div v-if="packageForm.relation_type === 1">
            <span class="label">关联全部</span>
            <el-tag type="warning">已关联全部课程，并自动关联新增课程</el-tag>
          </div>
          <div v-if="packageForm.relation_type === 2">
            <span class="label">部分关联</span>
            <el-tag type="warning"
              >已关联{{ packageForm.course_list.length }}个课程</el-tag
            >
          </div>
        </div>
        <div class="relate-course-wrap" v-if="packageForm.relation_type === 2">
          <span
            class="item"
            v-for="item in packageForm.course_list"
            :key="item.course_id"
            >{{ item.title }}</span
          >
        </div>
        <div>
          <div
            class="mwow-button success"
            @click="openRelateDialog"
            v-if="!isBasePackage"
          >
            修改关联
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div class="bottom-btns">
      <el-button class="mwow-button-filled" @click="$router.go(-1)"
        >取消</el-button
      >
      <el-button class="mwow-button-filled success" @click="handleSubmit"
        >保存</el-button
      >
    </div>
    <relate-dialog
      :related-list.sync="packageForm.course_list"
      :relation-type.sync="packageForm.relation_type"
      :visible.sync="relateDialogVisible"
    ></relate-dialog>
  </div>
</template>
<script>
import { positivePass, pricePass } from "@/utils/rules";
import {
  editCoursePackageApi,
  createCoursePackageApi,
  getCoursePackageDetailApi,
} from "@/api/course";
import relateDialog from "./relateDialog.vue";
export default {
  components: {
    relateDialog,
  },
  data() {
    return {
      packageForm: {
        name: "",
        quantity: "",
        price_1v1: "",
        price_1vn: "",
        status: 1,
        relation_type: 1,
        description: "",
        course_list: [],
      },
      relateDialogVisible: false,
      rules: {
        name: [{ required: true, message: "请填写课包名称", trigger: "blur" }],
        quantity: [
          { required: true, message: "请输入课时数量", trigger: "blur" },
          { validator: positivePass, trigger: "blur" },
        ],
        price_1v1: [
          { required: true, message: "请输入价格", trigger: "blur" },
          { validator: pricePass, trigger: "blur" },
        ],
        price_1vn: [
          { required: true, message: "请输入价格", trigger: "blur" },
          { validator: pricePass, trigger: "blur" },
        ],
        course_type: [
          { required: true, message: "请选择课程类型", trigger: "change" },
        ],
        status: [
          { required: true, message: "请选择上架状态", trigger: "change" },
        ],
        relation_type: [
          { required: true, message: "请选择关联类型", trigger: "change" },
        ],
      },
    };
  },
  created() {
    const id = Number(this.$route.query.id);
    if (id !== 0) {
      // 编辑
      getCoursePackageDetailApi({ package_id: id }).then((res) => {
        if (res.error_code === 0) {
          this.packageForm = {
            name: res.data.name,
            quantity: res.data.quantity,
            price_1v1: res.data.price_1v1,
            price_1vn: res.data.price_1vn,
            status: res.data.status,
            relation_type: res.data.relation_type,
            description: res.data.description,
            course_list: res.data.course_list,
          };
        }
      });
    }
  },
  computed: {
    isBasePackage() {
      return (
        this.$route.query.id !== "0" && Number(this.packageForm.quantity) === 1
      );
    },
  },
  methods: {
    openRelateDialog() {
      this.relateDialogVisible = true;
    },
    handleSubmit() {
      this.$refs["mainForm"].validate((valid) => {
        if (valid) {
          let option = {
            name: this.packageForm.name,
            quantity: Number(this.packageForm.quantity),
            status: this.packageForm.status,
            relation_type: this.packageForm.relation_type,
            price_1v1: this.packageForm.price_1v1,
            price_1vn: this.packageForm.price_1vn,
          };
          if (this.packageForm.description) {
            option.description = this.packageForm.description;
          }
          if (this.packageForm.relation_type === 2) {
            option.course_ids = this.packageForm.course_list.map((c) => {
              return c.course_id;
            });
            if (option.course_ids.length === 0) {
              this.$message({
                type: "warning",
                message: "请先选择关联课程",
              });
              return false;
            }
          }
          if (this.$route.query.id === "0") {
            // 新增
            createCoursePackageApi(option).then((res) => {
              if (res.error_code == 0) {
                this.$message({
                  type: "success",
                  message: "新增成功!",
                });
                this.$router.push({
                  name: "storeCourse",
                });
              } else {
                this.$message({
                  type: "error",
                  message: "新增失败!" + res.message,
                });
              }
            });
          } else {
            // 编辑
            option.package_id = Number(this.$route.query.id);
            editCoursePackageApi(option).then((res) => {
              if (res.error_code == 0) {
                this.$message({
                  type: "success",
                  message: "编辑成功!",
                });
                this.$router.push({
                  name: "storeCourse",
                });
              } else {
                this.$message({
                  type: "error",
                  message: "编辑失败!" + res.message,
                });
              }
            });
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  .mwow-form {
    padding: 24px 0;
    min-width: 540px;
  }
  .price-title {
    color: #5c5d5e;
    font-size: 12px;
  }
  .relate-wrap {
    margin-bottom: 12px;
    .label {
      color: #5c5d5e;
      font-size: 12px;
      margin-right: 24px;
    }
  }
  .relate-course-wrap {
    margin-bottom: 12px;
    .item {
      color: #45b13b;
      border: 1px solid #e7e8ea;
      border-radius: 4px;
      line-height: 28px;
      padding: 0 8px;
      margin-right: 10px;
      margin-bottom: 14px;
      display: inline-block;
    }
  }
  .bottom-btns {
  }
}
</style>
